import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-716eade6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cafes-theologiques" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "intro" }, " L’EITP promeut des formations spécifiques pour le renforcement des compétences (formations aux aumôniers, responsables de groupes, membres des conseils pastoraux paroissiaux) et des formations générales sur des thèmes spirituels (ouvertes à tous) pour l’enracinement de la foi et dans une perspective apologétique. Ces formations sont payantes et s’étendent sur trois ou quatre séances au plus. Les Cafés théologiques sont ouverts aux apprenants de l’école, selon des conditions particulières. Certains peuvent en profiter pour des rattrapages de cours selon que le thème abordé est en lien avec un module de cours. ", -1))
const _hoisted_3 = { class: "event-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "no-image"
}
const _hoisted_6 = { class: "event-content" }
const _hoisted_7 = { class: "event-title" }
const _hoisted_8 = { class: "event-subtitle" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (event, eIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: eIndex,
          class: "event-card"
        }, [
          _createElementVNode("div", _hoisted_3, [
            (event.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getUrlApiForFiles(event.urlImage),
                  alt: "image"
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucune image "))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(event.titre), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(event.sousTitre), 1),
            _createElementVNode("div", {
              class: "event-description",
              innerHTML: event.contenu
            }, null, 8, _hoisted_9)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_PaginationComponent, {
        page: _ctx.page,
        totalPages: _ctx.totalPages,
        totalElements: _ctx.totalElements,
        limit: _ctx.limit,
        onPaginate: _ctx.handlePaginate
      }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
    ])
  ]))
}